import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@aws-amplify/auth';
import { NbButtonModule, NbCardModule } from '@nebular/theme';
import { ENVIRONMENT } from 'src/environments/environment';

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css'],
  imports: [NbCardModule, NbButtonModule]
})
export class SignoutComponent implements OnInit {
  public environment = ENVIRONMENT.name;

  constructor(private router: Router) {}

  public ngOnInit(): void {
    Auth.signOut({ global: true });
  }

  public login() {
    this.router.navigate(['/login']);
  }
}
